import { createStandardAction } from 'typesafe-actions';

export const enableCustomTurnstileIntegration = createStandardAction(
  'customIntegration/TURNSTILE'
)<{}>();
